import Home from './pages/home';
import {BrowserRouter as Router} from 'react-router-dom';

// import logo from './logo.svg';
// import './App.css';

function App() {
  return (
    <Router>
      <Home />
    </Router>
  );
}

export default App;
